import React, { Fragment, useEffect, useState } from "react";
import CommonButton from "../../common/components/CommonButton";
import { ExamType } from "../../common/const";
import { Box, Grid, Typography } from "@mui/material";
import theme from "../../theme";
import CommonCard from "../../common/components/CommonCard";
import Events from "./Events";
import CoachTask from "../SAT ACT Coach/CoachTask";
import CommonFormField from "../../common/components/CommonFormField";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../features/authSlice";
import { getDashboardGraph } from "../../api/satactApi";
import ScoreHistory from "../SAT ACT Coach/ScoreHistory";
import RecentActivites from "../SAT ACT Coach/RecentActivities";
import { getInsights, updateInsight } from "../../api/mentorApi";

const SatActMentor = ({
    studentId,
    location,
    studentMentorId,
    currentService
}) => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [testType, setTestType] = useState(ExamType.SAT);
    const [coachInsight, setCoachInsight] = useState(null);
    const [state, setState] = useState({
        series: [{
            name: testType,
            data: []
        }],
        options: {
            stroke: {
                width: 2, // Change this to make line smaller (default is 2, try 1 for thinner)
                curve: 'smooth' // Optional: 'straight' for straight lines
            },
            chart: {
                height: 350,
                type: 'line',
                zoom: {
                    enabled: false
                },
                toolbar: {
                    show: false,
                },
            },
            dataLabels: {
                enabled: true
            },
            xaxis: {
                categories: [],
            },
            grid: {
                borderColor: '#e7e7e7',
                strokeDashArray: 5,
                yaxis: {
                    lines: {
                        show: true // This shows horizontal grid lines
                    }
                },
                xaxis: {
                    lines: {
                        show: true // Hide vertical grid lines if you want
                    }
                }
            },
        },
    });
    const [insights, setInsight] = useState(false);

    const getHistoryData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getDashboardGraph(testType, studentId);
            setState({
                series: [{
                    name: testType,
                    data: response.data?.map((a) => a.score)
                }],
                options: {
                    stroke: {
                        width: 2, // Change this to make line smaller (default is 2, try 1 for thinner)
                        curve: 'smooth' // Optional: 'straight' for straight lines
                    },
                    chart: {
                        height: 350,
                        type: 'line',
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: true
                    },
                    xaxis: {
                        categories: response.data?.map((a) => a.label),
                    },
                    grid: {
                        borderColor: '#e7e7e7',
                        strokeDashArray: 5,
                        yaxis: {
                            lines: {
                                show: true // This shows horizontal grid lines
                            }
                        },
                        xaxis: {
                            lines: {
                                show: true // Hide vertical grid lines if you want
                            }
                        }
                    },
                }
            });
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (location.pathname.split('/')[2]) {
            getHistoryData();
        }
    }, [location, testType]);

    const getInsightData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getInsights(studentId, user?.mentor?.mentor_profile_id);
            setCoachInsight(testType === ExamType.SAT ? response?.data?.sat_student_suggestion : response?.data?.act_student_suggestion);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        getInsightData()
    }, [testType]);

    return (
        <Fragment>
            <Box display="flex" gap={1}>
                <CommonButton
                    label={ExamType.SAT}
                    width="80px"
                    fontWeight={600}
                    color={testType === ExamType.SAT ? theme.palette.secondary.main : theme.palette.background.dark}
                    background={testType === ExamType.SAT ? theme.palette.primary.main : '#FAFAFA'}
                    handleClick={() => setTestType(ExamType.SAT)}
                    marginBottom="0px"
                    height="35px"
                    marginTop="0px"
                />
                <CommonButton
                    label={ExamType.ACT}
                    width="80px"
                    fontWeight={600}
                    color={testType === ExamType.ACT ? theme.palette.secondary.main : theme.palette.background.dark}
                    background={testType === ExamType.ACT ? theme.palette.primary.main : '#FAFAFA'}
                    handleClick={() => setTestType(ExamType.ACT)}
                    marginBottom="0px"
                    height="35px"
                    marginTop="0px"
                />
            </Box>
            <Grid container spacing={1}>
                <Grid item md={6} sm={12}>
                    <CommonCard
                        borderRadius={2}
                        background="#FFFCCF"
                        content={
                            <Fragment>
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography fontWeight={600} color={theme.palette.primary.main}>Coach Insight</Typography>
                                    {!insights && (
                                        <CommonButton
                                            label="Edit Insight"
                                            height="35px"
                                            width="120px"
                                            marginBottom="0px"
                                            marginTop="0px"
                                            handleClick={() => setInsight(true)}
                                        />
                                    )}
                                </Box>
                                {!insights ? (
                                    <Typography fontSize={14} color={theme.palette.background.dark}>
                                        {coachInsight}
                                    </Typography>
                                ) : (
                                    <Grid container spacing={2}>
                                        <Grid item sm={12}>
                                            <CommonFormField
                                                label="Coach Insights"
                                                type="email"
                                                name="message"
                                                value={coachInsight}
                                                onChange={(e) => setCoachInsight(e.target.value)}
                                                placeholder="Enter insight detail"
                                                multiline
                                            />
                                        </Grid>
                                        <Grid item sm={12}>
                                            <CommonButton
                                                label="Save"
                                                marginBottom="0px"
                                                marginTop="0px"
                                                fontWeight={600}
                                                background={theme.palette.secondary.main}
                                                color="White"
                                                handleClick={async () => {
                                                    if (coachInsight) {
                                                        if (coachInsight?.length <= 300) {
                                                            dispatch(setLoading({
                                                                loading: true
                                                            }));
                                                            let data = {};
                                                            if(testType === ExamType.SAT) {
                                                                data.sat_student_suggestion = coachInsight
                                                            } else {
                                                                data.act_student_suggestion = coachInsight
                                                            }
                                                            const response = await updateInsight(studentMentorId, data);
                                                            if (response?.success) {
                                                                showNotification(response?.message, 'success');
                                                                dispatch(setLoading({
                                                                    loading: false
                                                                }));
                                                                getInsightData();
                                                                setInsight(false);
                                                            }
                                                        } else {
                                                            showNotification('Maximum 300 characters allowed', 'error');
                                                        }
                                                    } else {
                                                        showNotification('Please enter insight detail', 'error');
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            </Fragment>
                        }
                    />
                </Grid>
                <Grid item md={6} sm={12}>
                    <Events currentService={currentService} studentId={studentId}/>
                </Grid>
                <Grid item md={12} sm={12}>
                    <CoachTask fromMentor studentId={studentId} testType={testType} title="Coach's Priority Tasks" currentService={currentService} />
                    <RecentActivites fromMentor testType={testType} studentId={studentId} currentService={currentService} />
                    <ScoreHistory state={state} fromMentor />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default SatActMentor;